import { z } from 'zod';

import { CartesianPose, ZERO_POSE } from '@sb/geometry';

// First link in the chain wrist -> [adapter] -> HexE -> bracket -> gripper.
// Only template today is the Flange Adapter for ISO80 to ISO50 (Thor-only).
export const MountingAdapterConfiguration = z.object({
  kind: z.literal('MountingAdapter'),
  name: z.string(),
  tcpTransform: CartesianPose.default(ZERO_POSE),
});

export type MountingAdapterConfiguration = z.infer<
  typeof MountingAdapterConfiguration
>;

export const MountingAdapterState = MountingAdapterConfiguration;

export type MountingAdapterState = z.infer<typeof MountingAdapterState>;
